import React from "react";
import { MainLayout } from "../../../components";
import { logout } from "../../../redux/actions/login";
import { handleMainTab } from "../../../redux/actions/premium/homeActions";
import { connect } from "react-redux";
import Menu from "./menu";

const SupportCenterPage = (props) => {
  return (
    <MainLayout logout={props.logout} stepHandler={props.handleMainTab}>
      <Menu />
    </MainLayout>
  );
};

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, { logout, handleMainTab })(
  SupportCenterPage
);
